import { z } from 'zod';

/**
 * email validation plus some added normalization (that is industry standard)
 */
export const email = () =>
  z
    .string()
    .email()
    // Some normalization of the email so that we can compare emails in the database
    .transform((email) => (email ? email.toLocaleLowerCase().trim() : ''));
